import React from 'react'
import { Container } from '@mui/material'
import { ArrowForward } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import TopHeader from '../Components/TopHeader'
import TitrePage from './TitrePage'
import Reveal from '../Components/ui/Reveal'
import ImageSlot from '../Components/ui/ImageSlot'
import SectionHeader from '../Components/ui/SectionHeader'
import ValueGrid from '../Components/ui/ValueGrid'
import CtaBand from '../Components/ui/CtaBand'
import { Images } from '../Data/Images'
import Cible from '../Data/Cible.json'

interface Props { }

function About(props: Props) {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate()
    const lang = i18n.language === 'fr' ? 0 : 1

    const go = (link: string) => {
        navigate(link)
        window.scrollTo({ top: 0 })
    }


    const values = [1, 2, 3, 4, 5].map((i) => ({
        title: t(`Carriere.Valeurs.valeur${i}.titre`),
        text: t(`Carriere.Valeurs.valeur${i}.contenu`),
    }))

    return (
        <div className="ibg-page">
            <TopHeader />
            <Header />
            <TitrePage image={Images.pageHeroes.about.src} titre={'titrePage.APropos.titre'} lien='About' pageDescription={'titrePage.APropos.description'} keyWords={'titrePage.APropos.keywords'} />

            <section id="about" className="ibg-section">
                <Container maxWidth="lg">
                    <div className="ibg-split">
                        <div className="ibg-split__text">
                            <SectionHeader eyebrow={t("APropos.texte1")} title={t("Texte.Accueil.Partie1.sousTitre")} />
                            <Reveal delay={0.1}>
                                <p className="ibg-body">{t("Texte.Accueil.Partie1.contenu")}</p>
                                <ul className="ibg-tags">
                                    {Cible.map((c) => <li key={c.id}>{c.title.split('|')[lang]}</li>)}
                                </ul>
                            </Reveal>
                        </div>
                        <Reveal delay={0.15} className="ibg-split__media">
                            <ImageSlot image={Images.about} ratio="4 / 5" />
                        </Reveal>
                    </div>
                </Container>
            </section>

            {/* <section className="ibg-section ibg-section--surface">
                <Container maxWidth="lg">
                    <SectionHeader eyebrow={t("APropos.texte5")} />
                    <div className="ibg-grid ibg-grid--3">
                        {Equipes.map((f) => (
                            <Project icon={<LinkedIn />} smallImale buttonName={t("consulter")} showBtn logo={f.image} link={f.link} linkName={f.title} date={""} title={f.title.split("|")[lang]} description={f.provider.split("|")[lang]} />
                        ))}
                    </div>
                </Container>
            </section> */}

            <section className="ibg-section ibg-section--surface">
                <Container maxWidth="lg">
                    <SectionHeader eyebrow={t("nom")} title={t("Carriere.texte5")} />
                    <ValueGrid items={values} />
                </Container>
            </section>

            <CtaBand title={t("APropos.texte17")} text={t("APropos.texte18")}>
                <button className="ibg-btn ibg-btn--light" onClick={() => go('/contact')}>
                    {t("contactUs")} <ArrowForward fontSize="small" />
                </button>
                <button className="ibg-btn ibg-btn--outline-light" onClick={() => go('/career')}>
                    {t("Carriere.texte4")}
                </button>
            </CtaBand>

            <Footer />
        </div>
    )
}

export default About
